import React, { useState } from 'react';
import { Card, Button, Form, Container } from 'react-bootstrap';
import { BsUpload } from 'react-icons/bs';
import { TbFileUpload } from "react-icons/tb";
import './styles_upload.css'



const UploadRefund = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    // Burada dosya yükleme işlemlerini gerçekleştirebilirsiniz
    // console.log(selectedFile);
  };

  return (
    <Container className="d-flex justify-content-center align-items-center upload-refund-container" style={{ minHeight: '100vh' }}>
      <Card className="upload-card">
        <Card.Body>
          <Form>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label className='form-title'>Açıklama (Zorunlu)</Form.Label>
              <Form.Control className='text-area' as="textarea" rows={3} placeholder="Konuyla ilgili detayları burada belirtebilirsiniz" />
            </Form.Group>
            <Form.Group controlId="formFileUpload" className="mb-3">
              <Form.Label className='form-title'>Ürün Fotoğrafları / Rapor (Zorunlu)</Form.Label>
              <p className='title-description'>Talebinizi açıklayan <span>görsel</span>, <span>kargo tutanağı</span> veya <span>servis raporu</span> ekleyebilirsiniz.</p>
              <div className="upload-area">
                <input type="file" onChange={handleFileSelect} />
                <BsUpload className="upload-icon" onClick={handleUpload} />
              </div>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UploadRefund;
